import { Divider, styled } from '@mui/material';

import Box from '@mui/material/Box';
import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import theme from 'src/themes';
import { v4 as uuidv4 } from 'uuid';

interface IProps {
  count: number;
}
const BreadCrumbsContainer = styled('div')(() => ({
  backgroundColor: theme.palette.common.white,
  maxWidth: theme.breakpoints.values.lg,
  margin: 'auto',
  padding: theme.spacing(2, 2, 2),
}));

const BreadcrumbSkeleton = (props: IProps) => {
  const { count } = props;
  // Utility function to generate unique keys
  const generateUniqueKeys = () =>
    Array.from({ length: count }, () => uuidv4());
  // prevent eslint error:  Do not use Array index in keys  react/no-array-index-key
  const uniqueKeys = generateUniqueKeys();

  return (
    <>
      <BreadCrumbsContainer data-testid="breadcrumbs-skeleton-container">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {uniqueKeys.map((key, index) => (
            <React.Fragment key={key}>
              <Skeleton
                variant="text"
                sx={{
                  fontSize: '1rem',
                  minWidth: '50px',
                  marginRight: index < count - 1 ? theme.spacing(1) : 0,
                }}
              />
              {index < count - 1 && (
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ marginX: theme.spacing(1) }}
                >
                  /
                </Typography>
              )}
            </React.Fragment>
          ))}
        </Box>
      </BreadCrumbsContainer>
      <Divider />
    </>
  );
};

export default BreadcrumbSkeleton;
